var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"background"},[_c('Info',{attrs:{"userInfo":_vm.userInfo,"show":_vm.show}}),_vm._v(" "),_c('Order')],1),_vm._v(" "),_c('Tools'),_vm._v(" "),_c('Recommend'),_vm._v(" "),_c('tabbar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260dce99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mine/index.vue
// module id = null
// module chunks = 